"use client"

import { useState } from "react"
import { useRouter } from "next/navigation"
import { Card, CardContent } from "@/components/ui/card"
import {
  Stethoscope,
  Building2,
  Brain,
  Laptop,
} from "lucide-react"

const organizationTypes = [
  {
    id: "medical",
    title: "Medical Practice",
    icon: Stethoscope,
    description: "Hospitals, clinics, physicians",
  },
  {
    id: "dental",
    title: "Dental Practice",
    icon: Building2,
    description: "Dental offices & orthodontists",
  },
  {
    id: "mental",
    title: "Mental Health",
    icon: Brain,
    description: "Therapists & counselors",
  },
  {
    id: "tech",
    title: "Healthcare Tech",
    icon: Laptop,
    description: "SaaS, EHR vendors, apps",
  },
]

export function OrgTypeSelector() {
  const router = useRouter()
  const [selectedOrgType, setSelectedOrgType] = useState<string | null>(null)

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {organizationTypes.map((org) => {
        const Icon = org.icon
        return (
          <Card
            key={org.id}
            className={`cursor-pointer transition-all hover:shadow-lg hover:border-[#0EA5E9] ${
              selectedOrgType === org.id
                ? "border-2 border-[#0EA5E9] bg-[#F0F9FF]"
                : "border-2 border-transparent"
            }`}
            onClick={() => {
              setSelectedOrgType(org.id)
              router.push(`/self-assessment?org=${org.id}`)
            }}
          >
            <CardContent className="pt-6 text-center">
              <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-[#E0F2FE] flex items-center justify-center">
                <Icon className="h-6 w-6 text-[#0EA5E9]" />
              </div>
              <h3 className="font-bold text-[#0F172A] mb-2">{org.title}</h3>
              <p className="text-sm text-[#64748B]">{org.description}</p>
            </CardContent>
          </Card>
        )
      })}
    </div>
  )
}
